import { isIpac } from './constants';

//getDomains
const defaultDomains = [
  {
    id: 1,
    name: 'Secrétariat',
    index: 1,
    icon: 'secretariat',
    displayTrainingIcon: true,
    defaultTrainingId: 3322,
  },
  {
    id: 2,
    name: 'Langues',
    index: 10,
    icon: 'langues',
    displayTrainingIcon: true,
    defaultTrainingId: 2988,
  },
  {
    id: 3,
    name: 'Nutrition',
    index: 17,
    icon: 'nutrition',
    displayTrainingIcon: true,
    defaultTrainingId: 2532,
  },
  {
    id: 4,
    name: 'Digital',
    index: 11,
    icon: 'digital',
    displayTrainingIcon: false,
    defaultTrainingId: 2186,
  },
  {
    id: 5,
    name: 'Marketing et communication',
    index: 5,
    icon: 'marketingEtCom',
    displayTrainingIcon: false,
    defaultTrainingId: 3676,
  },
  {
    id: 6,
    name: 'Décoration et design',
    index: 8,
    icon: 'deco',
    displayTrainingIcon: true,
    defaultTrainingId: 533,
  },
  {
    id: 7,
    name: 'Comptabilité et Gestion',
    index: 3,
    icon: 'compta',
    displayTrainingIcon: false,
    defaultTrainingId: 2216,
  },
  {
    id: 8,
    name: 'Esthétique et Beauté',
    index: 7,
    icon: 'esthetique',
    displayTrainingIcon: true,
    defaultTrainingId: 2475,
  },
  {
    id: 9,
    name: 'Ressources humaines et paie',
    index: 2,
    icon: 'rh',
    displayTrainingIcon: true,
    defaultTrainingId: 3364,
  },
  {
    id: 10,
    name: 'Petite enfance',
    index: 4,
    icon: 'petiteEnfance',
    displayTrainingIcon: true,
    defaultTrainingId: 3032,
  },
  {
    id: 11,
    name: 'Immobilier',
    index: 12,
    icon: 'immo',
    displayTrainingIcon: true,
    defaultTrainingId: 3234,
  },
  {
    id: 12,
    name: 'Graphisme, audiovisuel, PAO',
    index: 9,
    icon: 'graphisme',
    displayTrainingIcon: true,
    defaultTrainingId: 935,
  },
  {
    id: 13,
    name: 'Commerce et Vente',
    index: 6,
    icon: 'commerce',
    displayTrainingIcon: false,
    defaultTrainingId: 2991,
  },
  {
    id: 14,
    name: 'Management',
    index: 14,
    icon: 'management',
    displayTrainingIcon: true,
    defaultTrainingId: 2991,
  },
  {
    id: 16,
    name: 'Entrepreneuriat',
    index: 15,
    icon: 'entrepreneuriat',
    displayTrainingIcon: true,
    defaultTrainingId: 2978,
  },
  {
    id: 17,
    name: 'Logistique',
    index: 16,
    icon: 'logistique',
    displayTrainingIcon: true,
    defaultTrainingId: 3298,
  },
  {
    id: 18,
    name: 'Logiciels',
    index: 13,
    icon: 'logiciels',
    displayTrainingIcon: true,
    defaultTrainingId: 3409,
  },
];

const ipacDomains = [
  {
    id: 1,
    name: 'Secrétariat',
    index: 7,
    icon: 'secretariat',
    displayTrainingIcon: true,
    defaultTrainingId: 3061,
  },
  {
    id: 4,
    name: 'Digital',
    index: 8,
    icon: 'digital',
    displayTrainingIcon: false,
    defaultTrainingId: 2186,
  },
  {
    id: 5,
    name: 'Marketing et communication',
    index: 1,
    icon: 'marketingEtCom',
    displayTrainingIcon: false,
    defaultTrainingId: 3676,
  },
  {
    id: 7,
    name: 'Comptabilité et Gestion',
    index: 6,
    icon: 'compta',
    displayTrainingIcon: false,
    defaultTrainingId: 2216,
  },
  {
    id: 9,
    name: 'Ressources humaines et paie',
    index: 4,
    icon: 'rh',
    displayTrainingIcon: true,
    defaultTrainingId: 3364,
  },
  {
    id: 13,
    name: 'Commerce et Vente',
    index: 3,
    icon: 'commerce',
    displayTrainingIcon: false,
    defaultTrainingId: 2991,
  },
  {
    id: 14,
    name: 'Management',
    index: 5,
    icon: 'management',
    displayTrainingIcon: true,
    defaultTrainingId: 2991,
  },
  {
    id: 16,
    name: 'Entrepreneuriat',
    index: 2,
    icon: 'entrepreneuriat',
    displayTrainingIcon: true,
    defaultTrainingId: 2978,
  },
];

const defaultTrainingsDomainMatch = {
  3245: {
    domains: [7],
    positions: [2],
  },
  3322: {
    domains: [1],
    positions: [1],
  },
  3316: {
    domains: [ 7],
    positions: [ 2],
  },
  3292: {
    domains: [2],
    positions: [7],
  },
  3294: {
    domains: [2],
    positions: [9],
  },
  3296: {
    domains: [2],
    positions: [11],
  },
  3298: {
    domains: [17],
    positions: [3],
  },
  3566: {
    domains: [9],
    positions: [0],
  },
  3095: {
    domains: [9],
    positions: [7],
  },
  3096: {
    domains: [13, 14],
    positions: [11, 6],
  },
  3061: {
    domains: [1, 9],
    positions: [8, 6],
  },
  3062: {
    domains: [1, 13],
    positions: [9, 9],
  },
  3063: {
    domains: [1],
    positions: [10],
  },
  3048: {
    domains: [13],
    positions: [1],
  },
  2835: {
    domains: [13, 14, 16],
    positions: [5, 2, 1],
  },
  2824: {
    domains: [14, 13, 16],
    positions: [3, 6, 1],
  },
  2825: {
    domains: [14, 13],
    positions: [4, 7],
  },
  2797: {
    domains: [13, 16],
    positions: [4, 1],
  },
  533: {
    domains: [6],
    positions: [2],
  },
  2475: {
    domains: [8],
    positions: [4],
  },
  2435: {
    domains: [8],
    positions: [3],
  },
  2202: {
    domains: [6, 12, 18, 16],
    positions: [5, 7, 4, 1],
  },
  2203: {
    domains: [6, 12, 18, 16],
    positions: [4, 8, 5, 1],
  },
  2186: {
    domains: [4, 5],
    positions: [14, 14],
  },
  2463: {
    domains: [6, 12, 18, 16],
    positions: [3, 6, 3, 1],
  },
  3387: {
    domains: [4, 5],
    positions: [10, 12],
  },
  535: {
    domains: [6, 12, 18],
    positions: [6, 9, 6],
  },
  935: {
    domains: [12, 18, 16],
    positions: [2, 1, 1],
  },
  1807: {
    domains: [2, 13, 14, 16],
    positions: [4, 8, 5, 4],
  },
  2848: {
    domains: [6],
    positions: [7],
  },
  2361: {
    domains: [4],
    positions: [9],
  },
  2216: {
    domains: [7],
    positions: [12],
  },
  2380: {
    domains: [8],
    positions: [1],
  },
  3237: {
    domains: [4, 5, 16],
    positions: [2, 3, 1],
  },
  2436: {
    domains: [1],
    positions: [2],
  },
  2469: {
    domains: [8],
    positions: [2],
  },
  3234: {
    domains: [7, 11],
    positions: [3, 1],
  },
  3676: {
    domains: [5],
    positions: [4],
  },
  3677: {
    domains: [5],
    positions: [5],
  },
  3315: {
    domains: [7, 16],
    positions: [5, 1],
  },
  2520: {
    domains: [5],
    positions: [7],
  },
  2532: {
    domains: [3],
    positions: [1],
  },
  2548: {
    domains: [1],
    positions: [3],
  },
  3058: {
    domains: [7, 9],
    positions: [2, 1],
  },
  2564: {
    domains: [5, 16],
    positions: [9, 1],
  },
  3032: {
    domains: [10],
    positions: [1],
  },
  3650: {
    domains: [5],
    positions: [1],
  },
  2605: {
    domains: [7, 9, 16],
    positions: [7, 2, 1],
  },
  2636: {
    domains: [11, 16],
    positions: [3, 3],
  },
  2781: {
    domains: [1, 16],
    positions: [4, 1],
  },
  3040: {
    domains: [1, 16],
    positions: [6, 1],
  },
  2978: {
    domains: [11, 16],
    positions: [2, 2],
  },
  2988: {
    domains: [2],
    positions: [1],
  },
  2991: {
    domains: [14, 13, 16],
    positions: [1, 2, 1],
  },
  3021: {
    domains: [1, 16],
    positions: [5, 1],
  },
  3013: {
    domains: [9],
    positions: [3],
  },
  3364: {
    domains: [7, 9],
    positions: [8, 4],
  },
  3400: {
    domains: [14, 9],
    positions: [2, 10],
  },
  3401: {
    domains: [14, 9],
    positions: [2, 10],
  },
  3402: {
    domains: [14, 9],
    positions: [2, 10],
  },
  3409: {
    domains: [18, 7],
    positions: [2, 10],
  },
  3410: {
    domains: [18, 7],
    positions: [2, 11],
  },
  3427: {
    domains: [9],
    positions: [4],
  },
  3428: {
    domains: [9],
    positions: [5],
  },
  3451: {
    domains: [7],
    positions: [10],
  },
  3452: {
    domains: [7],
    positions: [12],
  },
  3673: {
    domains: [7],
    positions: [13],
  }
};

const ipacTrainingsDomainMatch = {
  3245: {
    domains: [7],
    positions: [2],
  },
  3058: {
    domains: [7, 9],
    positions: [2, 1],
  },
  3316: {
    domains: [7],
    positions: [2],
  },
  3566: {
    domains: [9],
    positions: [0],
  },
  3095: {
    domains: [9],
    positions: [7],
  },
  3096: {
    domains: [13, 14],
    positions: [11, 6],
  },
  3061: {
    domains: [1, 9],
    positions: [8, 6],
  },
  3062: {
    domains: [1, 13],
    positions: [9, 9],
  },
  3063: {
    domains: [1],
    positions: [10],
  },
  3048: {
    domains: [13],
    positions: [1],
  },
  2835: {
    domains: [13, 14, 16],
    positions: [5, 2, 1],
  },
  2824: {
    domains: [14, 13, 16],
    positions: [3, 6, 1],
  },
  2825: {
    domains: [14, 13],
    positions: [4, 7],
  },
  2797: {
    domains: [13, 16],
    positions: [4, 1],
  },
  2202: {
    domains: [16],
    positions: [ 1],
  },
  2203: {
    domains: [16],
    positions: [1],
  },
  2186: {
    domains: [4, 5],
    positions: [14, 14],
  },
  2463: {
    domains: [18, 16],
    positions: [ 3, 1],
  },
  3387: {
    domains: [4, 5],
    positions: [10, 12],
  },
  935: {
    domains: [12, 18, 16],
    positions: [2, 1, 1],
  },
  2361: {
    domains: [4],
    positions: [9],
  },
  3237: {
    domains: [4, 5, 16],
    positions: [2, 3, 1],
  },
  3676: {
    domains: [5],
    positions: [4],
  },
  3677: {
    domains: [5],
    positions: [5],
  },
  3315: {
    domains: [7, 16],
    positions: [5, 1],
  },
  2520: {
    domains: [5],
    positions: [7],
  },
  2564: {
    domains: [5, 16],
    positions: [9, 1],
  },
  3650: {
    domains: [5],
    positions: [1],
  },
  2605: {
    domains: [7, 9, 16],
    positions: [7, 2, 1],
  },
  2781: {
    domains: [1, 16],
    positions: [4, 1],
  },
  3040: {
    domains: [1, 16],
    positions: [6, 1],
  },
  2978: {
    domains: [11, 16],
    positions: [2, 2],
  },
  2991: {
    domains: [14, 13, 16],
    positions: [1, 2, 1],
  },
  3021: {
    domains: [1, 16],
    positions: [5, 1],
  },
  3013: {
    domains: [9],
    positions: [3],
  },
  3364: {
    domains: [7, 9],
    positions: [8, 4],
  },
  3400: {
    domains: [14, 9],
    positions: [1, 3],
  },
  3401: {
    domains: [14, 9],
    positions: [1, 3],
  },
  3402: {
    domains: [14, 9],
    positions: [1, 3],
  },
  3409: {
    domains: [18, 7],
    positions: [2, 10],
  },
  3410: {
    domains: [18, 7],
    positions: [2, 11],
  },
  3427: {
    domains: [9],
    positions: [4],
  },
  3428: {
    domains: [9],
    positions: [5],
  },
  3451: {
    domains: [7],
    positions: [10],
  },
  3452: {
    domains: [7],
    positions: [12],
  },
  3673: {
    domains: [7],
    positions: [13],
  }
};

export const getDomains = () => {
  if (isIpac) {
    return ipacDomains;
  } else {
    return defaultDomains;
  }
};

export const getDomainForTrainings = () => {
  if (isIpac) {
    return ipacTrainingsDomainMatch;
  } else {
    return defaultTrainingsDomainMatch;
  }
};
